<template>
    <div>
        <v-row v-for="(row,rowindex) in rows" :key="rowindex">
            <v-col v-for="(col,colindex) in row" :key="colindex" :cols="12 / row.length">
                <slot :item="col.item" :layout="col.layout" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'zoezi-card-layout',

    props: {
        items: {
            type: Array
        },
        maxPerRow: {
            type: Number,
            default: 4
        }
    },

    computed: {
        rows() {
            let items = this.items;
            let max = Math.max(1, this.maxPerRow);

            if (this.$vuetify.breakpoint.mobile) {
                return items.map(x => ([{item: x}]));
            }

            if (items.length === 0) return [];
            if (items.length === 1) return [[{item: items[0], layout: 'wide'}]];

            // If everything fits in one row, just use one row
            if (items.length <= max) {
                return [items.map(x => ({item: x}))];
            }

            // Distribute items evenly across rows to avoid lonely last cards
            // e.g. 9 items, max 3 → 3-3-3; 10 items, max 3 → 2-2-3-3
            const numRows = Math.ceil(items.length / max);
            const baseCount = Math.floor(items.length / numRows);
            const extra = items.length % numRows;

            let result = [];
            let offset = 0;
            for (let i = 0; i < numRows; i++) {
                const count = baseCount + (i >= numRows - extra ? 1 : 0);
                result.push(items.slice(offset, offset + count).map(x => ({item: x})));
                offset += count;
            }

            return result;
        },
    }
}
</script>
